import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Is writing the same as coding?",
  "description": "",
  "published": "2012-12-11T00:00:00.000Z",
  "redirect_from": ["/blog/is-writing-the-same-as-coding/swizec/5665"],
  "categories": "Arts, Ernest Hemingway, The Old Man and the Sea, Uncategorized, Writers Resources",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/12/hemingway-gellhorn-movie1.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/12/hemingway-gellhorn-movie1.jpg",
          "alt": "Hemingway&Gellhorn movie",
          "title": "Hemingway&Gellhorn movie"
        }}></img></a></p>
    <blockquote>
      <p parentName="blockquote">{`There is nothing to writing. All you do is sit down at a typewriter and bleed.`}</p>
      <p parentName="blockquote">{`~ `}<a parentName="p" {...{
          "href": "http://www.biography.com/people/ernest-hemingway-9334498",
          "title": "Ernest Hemingway"
        }}>{`Hemingway`}</a></p>
    </blockquote>
    <p>{`Lately I've been enamoured with Hemingway. Looking up to King is a great way to find a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Writing_style",
        "title": "Writing style"
      }}>{`writing style`}</a>{` people enjoy reading, but Hemingway looks like a way to write good content.`}</p>
    <p>{`Mostly I like his approach. At least what I've lately seen in movies of his character. There's been so many references to him lately it almost seems like the universe wants me to pick up a book of his and start reading. Movies, blogposts, comments on this or that forum ... he's everywhere.`}</p>
    <p>{`Shame my only memory of his content is watching `}<a parentName="p" {...{
        "href": "http://www.amazon.com/Old-Man-Sea-Ernest-Hemingway/dp/0684801221%3FSubscriptionId%3D0G81C5DAZ03ZR9WH9X82%26tag%3Dageewitahat-20%26linkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D0684801221",
        "title": "The Old Man and The Sea"
      }}>{`the Old Man and The Sea`}</a>{` movie as a kid and being totally, utterly, bored out of my skull.`}</p>
    <p>{`What really convinced me to start reading Hemingway was `}<a parentName="p" {...{
        "href": "http://byfat.xxx/if-hemingway-wrote-javascript"
      }}>{`his javascript`}</a>{`. `}<em parentName="p">{`"Code reduced to its essentials with no word or variable wasted."`}</em></p>
    <p>{`Writing like that isn't the easiest of things, much easier to fluff things up to seem important and educated. Then again, distilling things to their core will often leave readers with a lack of understanding, making too many assumptions and often missing the point you are trying to make.`}</p>
    <p>{`Easier for readers to hang on your exact words. Always.`}</p>
    <p>{`In that regard, the internet public is not much different than a compiler. It too will only look at exactly what you wrote, execute it so specifically it will make you cry. `}<em parentName="p">{`Why won't you do what I'm trying to tell you, you stupid computer!?`}</em></p>
    <p>{`Computers don't read between the lines.`}</p>
    <p>{`But they do add a lot of lines. First and foremost, a computer assumes you're an idiot. A far cry from the pure execution machines of the 1960's, computers these days perform so many optimisations on so many levels it's nearly impossible to tell what exactly is going to happen once you press Run.`}</p>
    <p>{`Though, at least a computer reads what you wrote before executing ... Most often, at least on the internet, readers will skim the first two paragraphs, decide what you were going to say, then start making assumptions and maaaaaybe fly through the rest of the text.`}</p>
    <p>{`Not like programming readers is hard enough already.`}</p>
    <p>{`Here you have a black box, you can't look at what's inside, but look, here's a language it understands. Your job is to use this language so the black box changes its internal state in a way to produce your desired effect. You can't know exactly what the changes should be, but they must produce this effect.`}</p>
    <p>{`Each black box behaves differently ...`}</p>
    <p>{`Go. Write something.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://hopepen.wordpress.com/2012/10/12/the-old-man-and-the-sea/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/118217162_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://hopepen.wordpress.com/2012/10/12/the-old-man-and-the-sea/"
        }}>{`The Old Man and the Sea- What is the struggle for?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://themodernmanuscript.wordpress.com/2012/11/18/hemingways-girl/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/126591132_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://themodernmanuscript.wordpress.com/2012/11/18/hemingways-girl/"
        }}>{`Hemingway's Girl`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thetalesofawriter.wordpress.com/2012/12/10/huffpost-my-writing-muse-booty-call/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/131461613_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://thetalesofawriter.wordpress.com/2012/12/10/huffpost-my-writing-muse-booty-call/"
        }}>{`HuffPost, My Writing Muse (Booty Call)`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://naimeless.wordpress.com/2012/10/14/1361/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/118675487_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://naimeless.wordpress.com/2012/10/14/1361/"
        }}>{`Writing authentically like Hemingway`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://musingbymoonlight.com/2012/11/26/hemingways-challenge/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/128096259_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://musingbymoonlight.com/2012/11/26/hemingways-challenge/"
        }}>{`Hemingway's Challenge`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=29cea4b9-11d8-4327-a440-490424f217b0",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      